const attributes = {
  animation: '[data-animation]',
}

const mount = () => {
  const targets = document.querySelectorAll(attributes.animation)
  if (targets.length === 0) return

  targets.forEach((target) => {
    intersectionViewport(target)
  })
}

const intersectionViewport = (target) => {
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      const { animation } = target.dataset
      entries.forEach((entrie) => {
        if (entrie.intersectionRatio > 0) {
          target.classList.add('s-animated', `s-${animation}`)
        } else {
          target.classList.remove('s-animated', `s-${animation}`)
        }
      })
    })

    observer.observe(target)
  }
}

export default { mount }
